// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"2ec0c30b","277":"c13bc394"}[chunkId] + ".chunk.css";
};